/* Product page additions on top of theme.js, loaded with defer from sections/main-product.liquid so
   it runs after theme.js has done its first render. Three jobs, all progressive enhancement:

   1. The gallery opens on the first image. theme.js scrolls to the photo of the first variant on
      load, and that is always a supplier photo, because only image 1 is our own hero. The hero is
      slide 0 in the DOM (data-colors is empty, so it is never filtered away), it was only scrolled
      past. A visitor who lands on a variant URL from a Shopping ad still gets that variant's photo.
   2. The colour pop-up. The row under the price opens it, the cards in it are rendered by Liquid,
      and choosing one writes into the hidden radios that theme.js already reads. That keeps the
      whole variant chain (price, size availability, gallery filter, sticky bar, the id the form
      submits) exactly where it was: this file only decides which radio is checked.
   3. Nothing for the size guide: that pop-up brings its own script.

   Without this file the radios still hold the first available colour, so the page still sells the
   product; the row simply does not open. */
(function () {
  'use strict';
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var onVariantUrl = /[?&]variant=\d/.test(window.location.search);

  $$('[data-product]').forEach(function (root) {
    /* ---- 1. start on the first image ------------------------------------------------- */
    var track = $('[data-gallery-track]', root);
    var touched = false;
    function toFirstImage() {
      if (!track || touched || track.scrollLeft === 0) return;
      track.scrollLeft = 0;
      /* theme.js redraws the counter on scroll through requestAnimationFrame, so asking for that
         redraw now keeps it from showing "2 / 12" for one frame before correcting itself. */
      track.dispatchEvent(new Event('scroll'));
    }
    if (track && !onVariantUrl) {
      toFirstImage();
      /* Browsers restore the scroll position of a scroller after the load event too, so the reset
         is repeated then. On a slow connection the visitor may already be swiping by that time,
         and pulling the gallery back to image 1 under their thumb would be worse than the problem
         it solves, so any touch or click on the gallery cancels the second reset. */
      ['pointerdown', 'touchstart', 'keydown'].forEach(function (type) {
        track.addEventListener(type, function () { touched = true; }, { passive: true, once: true });
      });
      window.addEventListener('load', toFirstImage, { once: true });
    }

    /* ---- 2. colour pop-up ------------------------------------------------------------ */
    var trigger = $('[data-colour-open]', root);
    var sheet = $('[data-colour-sheet]', root);
    if (!trigger || !sheet) return;

    var panel = $('.pdp-csheet__panel', sheet);
    var reel = $('[data-colour-reel]', sheet);
    var nameEl = $('[data-colour-name]', sheet);
    var okBtn = $('[data-colour-confirm]', sheet);
    var cards = $$('[data-colour-card]', sheet);
    var rowValue = $('[data-colour-value]', root);
    var rowThumb = $('[data-colour-thumb]', root);
    var optionIndex = sheet.getAttribute('data-colour-index');
    /* The words live in the Liquid, in one place, next to the ones theme.js reads off the section,
       so a store that renames them never has to touch this file. */
    var soldOutText = root.getAttribute('data-text-sold-out') || (window.storeStrings || {}).soldOut;
    var chooseText = okBtn ? okBtn.textContent.trim() : '';
    var marked = -1;

    if (!reel || !cards.length) return;

    /* The same variant list theme.js reads, parsed once and only when a colour is actually chosen,
       so a page where the pop-up stays shut pays nothing for it. */
    var variantData = null;
    function variantList() {
      if (variantData) return variantData;
      var el = $('script[data-variants]', root);
      try { variantData = el ? JSON.parse(el.textContent) : []; }
      catch (err) { variantData = []; }
      return variantData;
    }
    function checkedOptions() {
      var out = [];
      $$('[data-option-index]:checked', root).forEach(function (input) {
        out[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return out;
    }
    function hasAvailable(options) {
      return variantList().some(function (v) {
        if (!v.a) return false;
        for (var j = 0; j < options.length; j++) {
          if (options[j] !== undefined && v.o[j] !== options[j]) return false;
        }
        return true;
      });
    }
    /* A colour rarely comes in every size. Without this the size the shopper had stays checked, so
       choosing a colour that misses that size lands them on a sold out variant and they have to
       work out by themselves that the colour is for sale in another size. So: keep the size when
       the new colour has it, otherwise move to the first size that colour does have. Returns the
       radio it moved, or null when nothing had to move; sold out colours never get this far. */
    function repairSizes() {
      var options = checkedOptions();
      if (hasAvailable(options)) return null;
      var moved = null;
      $$('.option__values', root).forEach(function (group) {
        if (hasAvailable(options)) return;
        var inputs = $$('input[type="radio"][data-option-index]', group);
        if (!inputs.length) return;
        var idx = parseInt(inputs[0].getAttribute('data-option-index'), 10);
        for (var i = 0; i < inputs.length; i++) {
          var test = options.slice();
          test[idx] = inputs[i].value;
          if (!hasAvailable(test)) continue;
          inputs[i].checked = true;
          options = test;
          moved = inputs[i];
          break;
        }
      });
      return moved;
    }

    function centreOn(card, smooth) {
      if (!card || !reel.clientWidth) return false;
      var left = card.offsetLeft - (reel.clientWidth - card.offsetWidth) / 2;
      if (smooth && reel.scrollTo) reel.scrollTo({ left: left, behavior: 'smooth' });
      else reel.scrollLeft = left;
      return true;
    }

    /* mark writes the card in the middle into the name line and the Choose button; paint works out
       which card that is from the scroll position. They are split because a tap has to label the
       card it hit straight away: the scroll towards it is smooth, so reading scrollLeft in that
       same tick would still describe the card the shopper just left. */
    function mark(index) {
      if (index < 0 || index >= cards.length) return;
      cards.forEach(function (card, i) {
        card.classList.toggle('is-on', i === index);
        card.classList.toggle('is-near', Math.abs(i - index) === 1);
      });
      if (index === marked) return;
      marked = index;
      var card = cards[index];
      var name = card.getAttribute('data-colour') || '';
      var out = card.hasAttribute('data-soldout');
      if (nameEl) {
        nameEl.textContent = out ? name + ' (' + soldOutText + ')' : name;
        nameEl.classList.toggle('is-out', out);
      }
      if (okBtn) {
        okBtn.disabled = out;
        okBtn.textContent = out ? soldOutText : chooseText;
      }
    }
    function paint() {
      if (!reel.clientWidth) return;
      var middle = reel.scrollLeft + reel.clientWidth / 2;
      var best = 0;
      var bestDistance = Infinity;
      cards.forEach(function (card, i) {
        var distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - middle);
        if (distance < bestDistance) { bestDistance = distance; best = i; }
      });
      mark(best);
    }

    function currentCard() {
      return cards.filter(function (card) { return card.getAttribute('aria-pressed') === 'true'; })[0] || cards[0];
    }

    function open() {
      if (!sheet.hidden) return;
      sheet.hidden = false;
      document.body.classList.add('pdp-colour-open');
      trigger.setAttribute('aria-expanded', 'true');
      marked = -1;
      var card = currentCard();
      /* The panel has only just become visible, so the reel can still measure zero in this tick.
         A second go one frame later and a third after 60ms cover a slow first paint; each one
         stops as soon as the reel has a width. */
      if (!centreOn(card, false)) {
        window.requestAnimationFrame(function () { if (centreOn(card, false)) paint(); });
        window.setTimeout(function () { if (centreOn(card, false)) paint(); }, 60);
      }
      paint();
      if (card && card.focus) card.focus({ preventScroll: true });
    }

    function close() {
      if (sheet.hidden) return;
      sheet.hidden = true;
      document.body.classList.remove('pdp-colour-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (trigger.focus) trigger.focus({ preventScroll: true });
    }

    /* The hidden radios are the state theme.js reads, so this writes the choice there and lets the
       change event bubble to the section: price, size availability, gallery, sticky bar and the
       variant id in the form all follow from that one event, the same way they did with a select. */
    function applyColour(value) {
      var target = null;
      var changed = false;
      $$('[data-option-mirror="' + optionIndex + '"] input[type="radio"]', root).forEach(function (input) {
        var on = input.value === value;
        if (on) target = input;
        if (input.checked !== on) changed = true;
        input.checked = on;
      });
      var chosen = null;
      cards.forEach(function (card) {
        var on = card.getAttribute('data-colour') === value;
        if (on) chosen = card;
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
        card.classList.toggle('is-current', on);
      });
      if (rowValue) rowValue.textContent = value;
      var thumbSrc = chosen ? chosen.getAttribute('data-thumb') : null;
      if (rowThumb && thumbSrc && rowThumb.getAttribute('src') !== thumbSrc) rowThumb.setAttribute('src', thumbSrc);
      /* Only on a real colour change: pressing Choose on the colour that was already selected must
         not quietly move the shopper to another size. One change event covers both writes, because
         theme.js reads every checked radio when it fires. */
      var moved = changed ? repairSizes() : null;
      if (changed && target) target.dispatchEvent(new Event('change', { bubbles: true }));
      else if (moved) moved.dispatchEvent(new Event('change', { bubbles: true }));
    }

    trigger.addEventListener('click', open);
    reel.addEventListener('scroll', paint, { passive: true });

    reel.addEventListener('click', function (e) {
      var card = e.target.closest('[data-colour-card]');
      if (!card) return;
      /* Label first, then move. Focus goes onto the card because Safari does not focus a button on
         a click, and without it the focus would still be on the row behind the scrim, so the next
         Tab would walk into the page underneath instead of staying in the panel. */
      mark(cards.indexOf(card));
      if (card.focus) card.focus({ preventScroll: true });
      centreOn(card, true);
    });
    /* Tabbing or arrowing onto a card brings it to the middle, so what the keyboard is on and what
       the Choose button would take are never two different colours. */
    reel.addEventListener('focusin', function (e) {
      var card = e.target.closest('[data-colour-card]');
      if (card) centreOn(card, true);
    });
    reel.addEventListener('keydown', function (e) {
      var step = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') step = 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') step = -1;
      else if (e.key !== 'Home' && e.key !== 'End') return;
      var from = cards.indexOf(document.activeElement);
      if (from === -1) from = marked === -1 ? 0 : marked;
      var to = e.key === 'Home' ? 0 : e.key === 'End' ? cards.length - 1 : from + step;
      to = Math.max(0, Math.min(cards.length - 1, to));
      e.preventDefault();
      cards[to].focus({ preventScroll: true });
    });

    $$('[data-colour-close]', sheet).forEach(function (el) { el.addEventListener('click', close); });

    if (okBtn) {
      okBtn.addEventListener('click', function () {
        var card = cards[marked];
        /* The button is already disabled on a sold out colour, but the card stays reachable by
           scroll and by keyboard, so the choice is refused here as well. */
        if (!card || card.hasAttribute('data-soldout')) return;
        applyColour(card.getAttribute('data-colour'));
        close();
      });
    }

    /* Focus stays in the panel while it is open: the last control wraps to the first and back. */
    sheet.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !panel) return;
      var focusable = $$('button:not([disabled])', panel);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && !sheet.hidden) close();
    });

    /* ---- 3. size guide pop-up -------------------------------------------------------- */
    /* Nothing to do here. The controls carry data-size-guide-open and assets/size-guide.js, which
       comes with snippets/size-guide-modal.liquid, opens the dialog and keeps the focus. Opening it
       from this file as well would take the focus bookkeeping away from that script. Without a
       dialog on the page nothing cancels the click, so the control stays a link to the size guide
       page. */
  });
})();
